module.exports = __webpack_public_path__ + "media/images/application/template/logo-icon-66d3386b020898f48a374e7e1fad71da.svg";